import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ProgressBar from "./ProgressBar";
import TrackingHistory from "./TrackingHistory";
import copy_icon from "../../../../assets/images/copy_icon.svg";
import moment from "moment";
import Review from "../../../Review";
import apiService from "../../../../api/api.service";
import { setEdd } from "../../../../store/edd";
import { setFeatureSetting } from "../../../../store/featureSetting";
import EstimatedDeliveryDate from "../../theme_basic/EstimatedDeliveryDate";
import Copy from "../../../SVGS/icons/Copy";

const TrackingInfo = ({ order }) => {
  const { tracking_summary, tracking_manual, created_at, tracking_url } = order;
  const { enabled_edd } = useSelector((state) => state.featureSetting);

  const isInstallFbMessenger = window.facebookChatSettings?.app_status;
  const [isConnectFB, setIsConnectFB] = useState(false);
  const {
    trackingStatus: i18n,
    customStatus,
    customMessage: {
      replaceMessage,
      trackingUrl: { isActive, description },
    },
  } = useSelector((state) => state.settings);
  const dispatch = useDispatch();
  useEffect(() => {
    apiService.get("getAppSettings").then((res) => {
      if (res.data) {
        dispatch(setFeatureSetting(res?.data?.settings));

        setIsConnectFB(res.data.settings.fb_messenger_status);
        const enabledEdd = res?.data?.settings?.enabled_edd;
        if (enabledEdd == 1) {
          apiService.get("getEddSettings").then((res) => {
            if (res?.status == 200) {
              dispatch(setEdd(res?.data?.data));
            }
          });
        }
      }
    });
  }, []);
  const { tracking_form, tracking_history } = useSelector(
    (state) => state.i18n
  );

  const checkOrderNoInfo = () => {
    if (
      (tracking_summary === "courier_not_supported" &&
        tracking_manual === "courier_not_supported") ||
      (tracking_summary === "courier_not_supported" && !tracking_manual)
    ) {
      return true;
    }
    return false;
  };

  const { general: settings, reviewQuestions } = useSelector(
    (state) => state.settings
  );

  const trackingStatus =
    tracking_summary === "courier_not_supported"
      ? tracking_manual ?? tracking_summary
      : tracking_summary;

  const listStatus = {
    courier_not_supported: 0,
    information_received: 1,
    pending: 2,
    available_for_pickup: 2,
    in_transit: 3,
    failed_attempt: 4,
    exception: 4,
    expired: 4,
    out_for_delivery: 4,
    delivered: 5,
  };

  const activeIndex = listStatus[trackingStatus] ?? null;

  const isActiveCustomStatus =
    Math.abs(moment(created_at).diff(moment(), "days")) >=
    +customStatus.timeActive;

  let status;
  if (activeIndex === null) {
    if (customStatus.enabled && isActiveCustomStatus) {
      status = customStatus.label;
    } else {
      status = i18n.ordered;
    }
  } else {
    status = i18n[trackingStatus];
  }
  return (
    <div className="omg-special-tracking mt-5">
      <div className="omg-special-tracking-carrier">
        <div className="omg-special-tracking-carrier-logo"></div>
        {settings.show.includes("tracking_company") && (
          <div className="omg-special-tracking-carrier-name">
            {tracking_history.carrier}: {order?.tracking_company}
          </div>
        )}
      </div>
      <div className="omg-special-tracking-status text-uppercase">
        <span>{status}</span>
        {/* {reviewQuestions && <Review order={order} />} */}
      </div>
      <div className="omg-special-tracking-info">
        <div className="omg-special-tracking-info-number">
          {tracking_history.tracking_number}
          <span className="omg-special-tracking-number">
            {order?.tracking_number}
          </span>
          <span
            onClick={() =>
              navigator.clipboard.writeText(order?.tracking_number)
            }
            className="omg-special-tracking-copy"
          >
            {/* <img
              src={`${copy_icon}?v=1`}
              alt="Copy icon"
              style={{ cursor: "pointer" }}
            /> */}
            <Copy />
          </span>
          {isInstallFbMessenger && isConnectFB == "1" && (
            <span style={{ marginLeft: "20px" }}>
              <button
                onClick={() =>
                  window.document.querySelector(".ot-fb-logo").click()
                }
                className="omg-integration-fb"
              >
                Chat with seller
              </button>
            </span>
          )}
        </div>
        <div className="omg-special-tracking-info-number">
          {tracking_form.order_id}
          <span className="omg-special-tracking-number">{order?.name}</span>
        </div>
      </div>
      {!checkOrderNoInfo() ? (
        <div className="omg-special-tracking-progress-bar">
          {settings.show.includes("progress_bar") && (
            <ProgressBar order={order} />
          )}
          {settings.show.includes("tracking_logs") && (
            <TrackingHistory history={order.tracking_detail} />
          )}
          {enabled_edd == "1" && (
            <div className="omg-section-shipment-info omg-edd-date-bs">
              <EstimatedDeliveryDate order={order} />
            </div>
          )}
        </div>
      ) : (
        <>
          <div className="omg-custom-message">
            {/* <p className="omg-custom-message-replace mb-5">{replaceMessage}</p> */}
            {isActive && tracking_url && (
              <p className="omg-custom-message-url mb-5">
                {description.length !== 0
                  ? description
                  : "You might find alternative tracking here:"}{" "}
                <a
                  href={tracking_url}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                >
                  click here
                </a>
              </p>
            )}
          </div>
          {settings.show.includes("tracking_logs") && (
            <TrackingHistory history={order.tracking_detail} />
          )}
        </>
      )}
    </div>
  );
};

export default TrackingInfo;
